import { key } from 'core-ts-types';
import { ICourse, IPlannedCourse, ITermCourse } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export class TermCourse implements ICourse {
  static build(course: ICourse) {
    return new TermCourse(course);
  }
  id: number;
  nk: string;
  cd: string;
  subject: number;
  level: number;
  dept: number;
  title: string;
  credits: number; // Floating point number e.g. 3.0
  desc: string;
  coreq: number[]; // all coreqs for the course

  constructor(course: ICourse) {
    _4.merge(this, course);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/builders/term_course_builder.ts